import React from 'react';
import styles from '../irlObservations2026.module.css';
import { DetailHeader, DetailTabs, EvidenceUploadButton, FileRow, IrlCounts, UploadingEvidenceStatus } from './shared';

export default function IRL_Evidence({
    request,
    tab,
    onTab,
    onBack,
    onOpenAi,
    onCopy,
    copied,
    tabs,
    extraActions,
    onUpdateFields,
    onUploadEvidence,
    onOpenFile,
    busy,
    uploadingEvidence,
}) {
    const files = request.evidence || [];
    const uploadDisabled = busy || uploadingEvidence;
    return (
        <>
            <DetailHeader kind="irl" item={request} onBack={onBack} onOpenAi={onOpenAi} onCopy={onCopy} copied={copied} extraActions={extraActions} onUpdateFields={onUpdateFields} busy={busy} />
            <DetailTabs tabs={tabs} tab={tab} onTab={onTab} counts={IrlCounts(request)} />
            <div className={styles.detailBody}>
                <div className={styles.wideInner} aria-busy={uploadingEvidence ? 'true' : undefined}>
                    <div className={styles.sectionRow}>
                        <div className={styles.sectionLabelSm}>Supporting evidence</div>
                        <EvidenceUploadButton onUpload={onUploadEvidence} disabled={uploadDisabled} />
                    </div>
                    {uploadingEvidence ? <UploadingEvidenceStatus /> : null}
                    {files.length === 0 && !uploadingEvidence ? (
                        <div className={styles.emptyResponse}>
                            <p className={styles.emptyTitle}>No evidence linked</p>
                            <p className={styles.emptyBody}>Documents linked to this request will appear here.</p>
                        </div>
                    ) : (
                        files.map(file => <FileRow key={file.documentId || file.name} file={file} onOpen={onOpenFile} />)
                    )}
                </div>
            </div>
        </>
    );
}
